import { connect } from 'react-redux'
import { bindActionCreators } from 'redux'
import compose from 'recompose/compose'
import withHandlers from 'recompose/withHandlers'

import * as PlaybookActions from 'app/modules/playbook/actions'
import * as PlaybookSelectors from 'app/modules/playbook/selectors'

import MatchAnswerBody from './component'

const mapStateToProps = state => ({
  answer: PlaybookSelectors.getCurrentAnswer(state),
  skipToOptions: PlaybookSelectors.skipToOptions(state),
  currentSkipToOption: PlaybookSelectors.currentSkipToOption(state),
})

const mapDispatchToProps = dispatch => ({
  actions: bindActionCreators(
    {
      setSkipTo: PlaybookActions.setSkipTo,
    },
    dispatch
  ),
})

export default compose(
  connect(mapStateToProps, mapDispatchToProps),
  withHandlers({
    onSkipToChange: props => value => {
      const { actions: { setSkipTo }, answer: { id: answerId }} = props
      const { isGoal = false, id: skipToId = null } = value ? value.value : {}
      setSkipTo({ answerId, isGoal, skipToId })
    },
  })
)(MatchAnswerBody)



// WEBPACK FOOTER //
// ./src/scripts/components/playbook/components/AnswerModal/AnswerModalMatchBody/index.js